var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlechaArribaPasivo24X24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5695 15.298C19.3 15.6125 18.8265 15.649 18.512 15.3795L12.2888 10.0468C12.1207 9.90108 11.8793 9.90108 11.7112 10.0468L11.708 10.0495L5.488 15.3795C5.17347 15.649 4.7 15.6125 4.43048 15.298C4.16095 14.9835 4.19744 14.51 4.51197 14.2405L10.7288 8.91323L10.7306 8.91166C11.4619 8.27943 12.5382 8.27944 13.2694 8.91171L19.488 14.2405C19.8025 14.51 19.839 14.9835 19.5695 15.298Z",
    fill: "#F07B43"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlechaArribaPasivo24X24);
export default __webpack_public_path__ + "static/media/FLECHA_ARRIBA_PASIVO_24X24.2ccf203d0dd73bed7d8bf1140f61243c.svg";
export { ForwardRef as ReactComponent };